import { SVGProps } from '@/interfaces/SVGProps';

const Cross = ({ className, width = 32, height = 32 }: SVGProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 32 32' className={className}>
    <path d='M25.708 24.293a.999.999 0 0 1-.324 1.631 1.002 1.002 0 0 1-1.09-.216L16 17.414l-8.293 8.294a1 1 0 0 1-1.415-1.415L14.587 16 6.293 7.708a1 1 0 1 1 1.415-1.415l8.293 8.293 8.292-8.293a1 1 0 1 1 1.415 1.415L17.414 16l8.294 8.293Z' />
  </svg>
);
export default Cross;
